module.exports = __webpack_public_path__ + "img/arrow.79f902b7.svg";